export const SearchExhangeRatePublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">환율정보 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">고시회차</label>
                            <select className="form-select w-150px">
                                <option>출하요청</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">기준</label>
                            <div className="frm_field">
                                <select className="form-select w-150px">
                                    <option>기간 환율</option>
                                </select>
                                <div className="frm_field input_date">
                                    <input type="date" className="form-control" />
                                    <span className="txt_range">~</span>
                                    <input type="date" className="form-control" />
                                    <button className="btn btn-info btn_search">
                                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">환율정보 상세보기</h6>
                    <div className="table_toolbar">
                        <div className="stats">
                            <div className="stats_item">기준일<span>2024-05-01 ~ 2024-05-10</span></div>
                            <div className="stats_item">고시회차<span>최종</span></div>
                        </div>
                    </div>
                </div>

                <table className="table table-bordered my_table mb-0">
                    <thead>
                        <tr>
                            <th rowSpan={2} style={{ width: "16.66%" }}>통화</th>
                            <th colSpan={2} style={{ width: "33.33%" }}>현찰</th>
                            <th colSpan={2} style={{ width: "33.33%" }}>송금</th>
                            <th rowSpan={2}>매매기준율</th>
                        </tr>
                        <tr>
                            <th style={{ width: "16.66%" }}>사실 때</th>
                            <th style={{ width: "16.66%" }}>파실 때</th>
                            <th style={{ width: "16.66%" }}>사실 때</th>
                            <th>파실 때</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-center">USD(미국)</td>
                            <td className="text-end">1,200</td>
                            <td className="text-end">1,200</td>
                            <td className="text-end">1,200</td>
                            <td className="text-end">1,200</td>
                            <td className="text-end">1,200</td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </>
    );
}